import React from 'react';
import { useRef,useLayoutEffect, useEffect,useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FaPlusSquare } from 'react-icons/fa';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FaMinusSquare } from 'react-icons/fa';
import { TranslateString } from 'Utils/Common';
import './FinancialAnalysisTree.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const customTree = [
	{
		title : "Fermentum Ultrices",
		value : "",
		isExpand:false,
		tree:[
			{
				title : "Consectetur rhoncus",
				value : "",
			},
			{
				title : "Etam enim suspendisse",
				value : "",
			},
			{
				title : "Bibendum nec malesuada",
				value : "",
			},
			{
				title : "Imperdiet nisl tempar",
				value : "",
			},
			{
				title : "Tincidunt morbi libero",
				value : "",
			},
			{
				title : "Lobortis nulla ",
				value : "",
			},
		]
	},
	{
		title : "Vivamus aliquam",
		value : "",
		isExpand:false,
		tree:[
			{
				title : "Consectetur rhoncus",
				value : "",
				isExpand:false,
				tree:[
					{
						title : "Consectetur rhoncus",
						value : "",
					},
					{
						title : "Etam enim suspendisse",
						value : "",
					},
					{
						title : "Bibendum nec malesuada",
						value : "",
					},
					{
						title : "Imperdiet nisl tempar",
						value : "",
					},
					{
						title : "Tincidunt morbi libero",
						value : "",
					},
					{
						title : "Lobortis nulla ",
						value : "",
					},
				]
			},
		]
	}
];

const FinancialAnalysisTree  = (props:any) => {
	const targetRef:any = useRef();
	const [dimensions, setDimensions] = useState({ width: 100, height: 0 });
	const [treeData, setTreeData] = useState<any[]>([]);

	useEffect(() => {
		let originalData = generateHeirarchy(props?.data?.category)
		setTreeData(originalData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

	useLayoutEffect(() => {
		if (targetRef.current) {
		  setDimensions({
			width: targetRef.current.offsetWidth <120?120:targetRef.current.offsetWidth+10,
			height: targetRef.current.offsetHeight
		  });
		}
	
	  }, [props]);
	


	function generateHeirarchy(data:any){
		return data?.map((element:any)=>{
			if(element?.tree){
				element.tree = generateHeirarchy(element.tree);
			}
			element.isExpand=true;
			// if(props?.isExpand){
			// 	element.isExpand=props?.isExpand;
			// }else{
			// 	element.isExpand=false;
			// }
			return element;
		})
	}

	let treeEvent = (indexElement:any,tempTreeData:any)=>{
		
		return tempTreeData?.map((elementData:any,index:any)=>{
			if(elementData===indexElement){
				elementData.isExpand=elementData?.isExpand?false:true;
			}else if(Array.isArray(elementData?.tree)){
				elementData.tree=treeEvent(indexElement,elementData?.tree);
			}
			return elementData
		})
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	let setTreeEvent = (indexElement:any)=>{
		let data = treeEvent(indexElement,treeData);
		setTreeData(data)
	}
	
	let generateTree = (tree:any,indexData:any=null) =>{
		let keyIndex:any  = (Number(Math?.random()) *10000000000)?.toFixed(0);
		return tree?.map((element:any,index:any)=>{
			let html = <tr key={`main-`+keyIndex}>
				<td className={`text-left `} >
					{/* <button onClick={(event)=>{setTreeEvent(element)}}  value="+" className="cu-btn-style-none">&nbsp;{element?.tree?(element?.isExpand?<FaMinusSquare />:<FaPlusSquare />):""}</button>&nbsp; */}
					{element?.title}
				</td>
				<td style={{width:dimensions?.width+'px'}} className={`text-end`}>
					{element?.value ? element.value+"€" :"" }&nbsp; 
				</td>
			</tr>
			let tempHtml;
			if(element.tree){
				tempHtml = <tr className={element?.isExpand || props?.isExpand?"":"cu-d-none"} key={`submenu-`+keyIndex}>
					<td colSpan={2} className="p-0">
						<div className='cu-ml-20'>
							<table width="100%" cellSpacing={0} style={{marginLeft:"2px",marginTop:"-1px"}} className="table table-sm table-bordered mb-0">
								<tbody>
									{generateTree(element.tree,indexData)}
								</tbody>
							</table>
						</div>
					</td>
				</tr>
			}

			return (
				<React.Fragment key={Math.random()}>{html}{tempHtml}</React.Fragment>
			);
		})
	}

	return (
		<>
			<div className="cu-shading-none pl-2" style={{width:"50%"}}>
				<table className="table table-sm table-bordered" width="100%" key={Math.random()?.toString()}>
					<tbody className={props?.tbodyClass}>
						<tr className="cu-bg-green">
							<td className="text-left fw-600">&emsp;{TranslateString('Maksuvalmiuserittely')}</td>
							<td className="text-left px-1 fw-600" style={{width:'100px'}} >{TranslateString('Maksuvalmius')}</td>
						</tr>
						{generateTree(treeData)}
						<tr>
							<td className="text-end">Yhteensä</td>
							<td className="text-end pr-1"><div ref={targetRef}>{props?.data?.Yhteensa || 0}€&nbsp; </div></td>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	);
};

export default React.memo(FinancialAnalysisTree);
